





































import { Vue, Component } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';

@Component
export default class AccountDisabled extends Vue {
  get supportEmailOrPhone() {
    let email = vxm.configs.getGlobalConfigValue('SUPPORT_EMAIL') || vxm.utility.supportEmail;
    if (email && this.supportPhoneNo) {
      return `${email} or ${this.supportPhoneNo}`;
    }
    return email ? email : '';
  }

  get getUserEmail() {
    let profile = vxm.users.myUserProfile;
    if (profile && profile.email) {
      return profile.email;
    }
    return '';
  }

  showFindJobsPage() {
    this.$router.push({ name: 'Findjobs' });
  }

  get supportPhoneNo() {
    return (
      vxm.configs.getGlobalConfigValue('SUPPORT_PHONE_NUMBER') || vxm.utility.supportPhoneNo
    );
  }
}
